// SeccionContenido.jsx

import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import ImageWithBlur from "./ImageWithBlur";

// ==============================================
// FUNCIONES INTERNAS (AUTOCONTENIDAS) 
// ==============================================

// Función utilitaria para extraer valor numérico de precios (DUPLICADA)
const parsePrice = (priceString) => {
  if (!priceString || priceString === "Gratis" || priceString === "Gratuito") return 0;
  // Eliminar símbolos de moneda, espacios y puntos, mantener solo números
  const numericValue = priceString.replace(/[^\d]/g, '');
  return parseInt(numericValue) || 0;
};

// ==============================================
// COMPONENTE PRINCIPAL DE LA SECCIÓN
// ==============================================

function SeccionContenido({ 
  profesionalInfo, 
  handleComprarClick,
  isMobile 
}) {

  const renderContentCards = () => {
    if (!profesionalInfo || !profesionalInfo.contenidos) {
      return null;
    }

    const contenidos = profesionalInfo.contenidos;

    if (!contenidos || contenidos.length === 0) {
      return null;
    }

    // Ordenar contenidos por precio de mayor a menor
    const sortedContenidos = [...contenidos].sort((a, b) => {
      const priceA = parsePrice(a.contenido_precio_clp);
      const priceB = parsePrice(b.contenido_precio_clp);
      return priceB - priceA; // Orden descendente (más caro primero)
    });

    return (
      <>
        {sortedContenidos.map((contenido) => (
          <Card
            key={contenido.id_contenido}
            sx={{ mb: 2, borderRadius: 2, boxShadow: 3 }}
          >
            <CardContent>
              <Box sx={{ 
                display: "flex", 
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "center", md: "center" },
                gap: { xs: 0, md: 2 },
                mb: 0 
              }}>
                {/* Imagen */}
                <Box sx={{ 
                  maxWidth: { xs: "90%", md: "300px" }, // Cambiado de 350px a 300px
                  width: { xs: "280px", md: "300px" }, // Cambiado de 350px a 300px para coincidir con ancho de imagen
                  height: { xs: "120px", md: "150px" },
                  mb: { xs: 2, md: 0 },
                  display: "flex",
                  justifyContent: "flex-start", // Cambiado de "center" a "flex-start"
                  flexShrink: 0
                }}>
                  <ImageWithBlur
                    src={contenido.contenido_foto}
                    alt={contenido.contenido_nombre}
                    width={isMobile ? "280px" : "300px"}
                    height={isMobile ? "120px" : "150px"}
                  />
                </Box>
                
                {/* Información del producto */}
                <Box sx={{ 
                  width: { xs: "100%", md: "auto" },
                  flex: { xs: "none", md: 1 },
                  textAlign: { xs: "left", md: "left" }, // Centrado en mobile, izquierda en desktop
                  display: "flex", 
                  flexDirection: "column", 
                  minHeight: { xs: "auto", md: "150px" },
                  mb: 0 
                }}>
                    <Typography
                      sx={{ fontFamily: "Quicksand-Bold", fontSize: { md: "16px", xs: "14px" }, mb: 0 }}
                    >
                      {contenido.contenido_nombre}
                    </Typography>
                    
                    <Box
                      sx={{
                        display: "inline-block",
                        backgroundColor: "#f0f4ff",
                        color: "#3B82F6",
                        fontFamily: "Quicksand-Medium",
                        fontSize: { md: "15px", xs: "13px" },
                        borderRadius: 2,
                        paddingLeft: 0.75,
                        paddingRight: 0.75,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        mb: 0.25,
                        marginLeft: -0.75,
                        textAlign: "left",
                        width: "auto",
                        alignSelf: "flex-start",
                      }}
                    >
                      Contenido
                    </Box>
                    
                    <Typography
                      sx={{ fontFamily: "Quicksand-Bold", color: "#3B82F6", mb: 2, fontSize: { md: "16px", xs: "14px" } }}
                    >
                      {contenido.contenido_precio_total_clp}
                    </Typography>

                    {/* Espacio flexible solo en desktop */}
                  <Box sx={{ flex: { xs: 0, md: 1 } }} />
                  
                  {/* Botón */}
                  <Box sx={{ 
                    display: "flex", 
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: { xs: "flex-start", md: "flex-end" },
                    alignItems: { xs: "stretch", md: "flex-end" },
                    gap: { xs: 2, md: 0 },
                    width: { xs: "100%", md: "auto" },
                    mb: 0 
                  }}>
                    <Button
                      variant="contained"
                      disableRipple
                      disableElevation
                      disableFocusRipple
                      onClick={() => handleComprarClick(contenido)}
                      sx={{
                        fontFamily: "Quicksand-Bold",
                        backgroundColor: "#3B82F6",
                        "&:hover": { 
                          backgroundColor: "#3B82F6",
                          boxShadow: "none !important",
                        },
                        "&:active": {
                          backgroundColor: "#3B82F6",
                          boxShadow: "none !important",
                        },
                        "&:focus": {
                          backgroundColor: "#3B82F6",
                          boxShadow: "none !important",
                        },
                        borderRadius: 2,
                        width: { xs: "100%", md: "auto" },
                        py: 1,
                        fontSize: { md: "16px", xs: "14px" },
                        boxShadow: "none !important",
                        transition: "none !important",
                        "& .MuiTouchRipple-root": {
                          display: "none",
                        },
                      }}
                    >
                      Ver más
                    </Button>
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>
        ))}
      </>
    );
  };

  // Renderizado condicional de la sección completa
  if (!profesionalInfo || !profesionalInfo.contenidos || profesionalInfo.contenidos.length === 0) {
    return null;
  }

  return (
    <>
      {/* 4. TIENDA (si existe) */}
      <Typography
        sx={{
          mt: 3,
          mb: 2,
          fontFamily: "Quicksand-Bold",
          fontSize: { md: "20px", xs: "18px" },
        }}
      >
        Contenido
      </Typography>
      {renderContentCards()}
    </>
  );
}

export default SeccionContenido;
